// extracted by mini-css-extract-plugin
export default {"button":"Button_button__A76z0","fill":"Button_fill__cKJTE","accent":"Button_accent__BsGK+","outline":"Button_outline__YUST8"};